import { Component, OnInit } from '@angular/core';
import {HttpClientService} from '../../Services/http-client.service';
import {AppSettings} from '../../app-settings';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-activity-details-body-forum-view',
  templateUrl: './activity-details-body-forum-view.component.html',
  styleUrls: ['./activity-details-body-forum-view.component.css']
})
export class ActivityDetailsBodyForumViewComponent implements OnInit {

  constructor(private httpClientService: HttpClientService) { }
  userRole:string;
 ngOnInit() {
    this.getForumsData();
  }

  getForumsData()
  {
    let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl + 
          '/api/activity/26/forum/0/', headers)
      .subscribe(
      (data) => {
          this.userRole = data.userType;
      }
      );
  }

}
